<div class="form-group">
    <label class="ui-checkbox input-label">
    <input class="form-control" name="multiple" type="checkbox" value="{{fieldOptions.multiple}}"
           [(ngModel)]="fieldOptions.multiple">
    <span><b>Multiple</b></span>
  </label>
</div>